// extracted by mini-css-extract-plugin
export default {"tile_container":"Sca","tile_img_container":"Tca","not_recommended_label":"Uca","modal_root":"Vca","content":"Wca","warning":"Xca","x_mark":"Yca","tile_img":"Zca","tile_type":"aea","tile_product_title":"bea","tile_product_price":"cea","tile_descr_line":"eea","tile_descr_icon":"fea","info_icon":"gea","tile_descr_text":"hea","tile_btns_container":"iea","info_container":"jea","info_text":"kea"};
    if(module.hot) {
      // 1738836199187
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  